<div class="space-y-4">
  <p class="text-xs text-gray-500 dark:text-gray-400">Los miembros se usan para modos round-robin / collective / group event.</p>

  <div class="p-3 rounded-lg border border-gray-200 dark:border-gray-700 grid grid-cols-1 md:grid-cols-[1fr_auto_auto] gap-2 items-end">
    <div>
      <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">Usuario</label>
      <app-entity-select
        [value]="newUserId"
        (valueChange)="newUserId = $event"
        [searchFn]="userSearch"
        [labelFn]="userLabel"
        [sublabelFn]="userSublabel"
        placeholder="Buscar por nombre o correo…"></app-entity-select>
    </div>
    <div>
      <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">Peso</label>
      <input type="number" min="1" [(ngModel)]="newWeight"
        class="w-20 px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white">
    </div>
    <button type="button" (click)="add()" [disabled]="saving || !newUserId"
      class="px-3 py-1.5 text-sm rounded-lg font-medium bg-brand-500 text-white hover:bg-brand-600 disabled:opacity-50">
      + Agregar
    </button>
  </div>

  @if (loading) {
    <p class="text-sm text-gray-500 dark:text-gray-400">Cargando...</p>
  } @else if (items.length === 0) {
    <p class="text-sm text-gray-500 dark:text-gray-400">Sin miembros.</p>
  } @else {
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-3">
      @for (item of items; track item.id) {
        <div class="rounded-lg border border-gray-200 dark:border-gray-700 p-3 flex items-start justify-between gap-3"
          [class.opacity-60]="!item.isActive">
          <div class="flex items-start gap-3 min-w-0">
            <!-- Avatar con iniciales -->
            <span class="flex-shrink-0 w-10 h-10 rounded-full bg-brand-50 dark:bg-brand-500/15 text-brand-600 dark:text-brand-300 flex items-center justify-center text-sm font-semibold uppercase">
              {{ (userNames[item.idUser] || ('U' + item.idUser)).charAt(0) }}
            </span>
            <div class="min-w-0">
              <p class="font-medium text-gray-900 dark:text-white text-sm truncate">{{ userNames[item.idUser] || 'Usuario no disponible' }}</p>
              @if (userEmails[item.idUser]) {
                <p class="text-xs text-gray-500 dark:text-gray-400 truncate">{{ userEmails[item.idUser] }}</p>
              }
              <div class="flex items-center gap-2 mt-2 flex-wrap">
                <label class="text-xs text-gray-600 dark:text-gray-400 flex items-center gap-1">
                  Peso:
                  <input type="number" min="1" [ngModel]="item.priorityWeight"
                    (change)="updateWeight(item, +$any($event.target).value)"
                    class="w-16 px-1.5 py-0.5 text-xs border border-gray-300 dark:border-gray-600 rounded bg-white dark:bg-gray-800 text-gray-900 dark:text-white">
                </label>
                @if (!item.isActive) { <span class="text-xs px-2 py-0.5 rounded bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300">Inactivo</span> }
              </div>
            </div>
          </div>
          <div class="flex flex-col items-end gap-2 flex-shrink-0">
            <button type="button" (click)="toggle(item)"
              class="text-xs px-2 py-1 rounded border border-gray-300 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-300">
              {{ item.isActive ? 'Desactivar' : 'Activar' }}
            </button>
            <button type="button" (click)="remove(item)"
              class="text-xs px-2 py-1 rounded border border-error-300 text-error-600 hover:bg-error-50">
              Quitar
            </button>
          </div>
        </div>
      }
    </div>
  }
</div>
